import { ClubStats } from "@/redux/myClub/myClubSlice";

import axios from "../../privateApi";

export const getStats = async (): Promise<ClubStats> => {
  const res = await axios.get("/user-clubs/stats");
  return res.data;
};

export default getStats;
